import '../components/custom-dropdown';
import '../form';


/**
 *  Javascript utilisé par le bloc "Actu stage" présent sur la home et sur les pages agences
 * 
 */
 (function(w) {
    // Définit l'objet Completude
    w.Completude = Object.assign({},w.Completude);
    w.Completude.bloc_recherche_offres  = {                
        /**
         * Initialisation 
         */
        InitBlocRechercheOffre() {

            let filtreRecherche = Completude.GetStorage('search-offers') ;
                                
            Completude.bloc_recherche_offres.$form = Completude.SetFormValidation(jQuery('#recherche-offres-form'));                   
            
            //Initialisation de l'adresse
            if (typeof(filtreRecherche)!==undefined && filtreRecherche!==null && typeof filtreRecherche.localisation!='undefined' && filtreRecherche.localisation!==null) {
                jQuery("#field-address").SetLocalisation(filtreRecherche.localisation);                
            }

            //Initialisation du custom dropdown avec les matières précochées
            jQuery(".js-custom-dropdown").CustomDropdown(filtreRecherche !== null && typeof filtreRecherche.matieres !== 'undefined' ? filtreRecherche.matieres : null );
                        

            // Clic sur le bouton de recherche pour une redirection vers la page offre-emploi
            jQuery('#search-offers-block').on('click', function (event) {
              event.preventDefault();
              if (Completude.bloc_recherche_offres.$form.validate()) {
                Completude.bloc_recherche_offres.Rechercher();               
              } 
            });  

        },
        /** Clic sur le bouton de recherche */ 
        Rechercher() {            
            
            // Matières
             var matieres = [];
             jQuery('input[name="subjects"]:checked').each(function () {
                    matieres.push(this.value)
             });
            
            //    Sauvegarde la recherche                                                
            Completude.SetStorage('search-offers',  {localisation : autocomplete.localisation, matieres : matieres });
               
                
            /** Clic sur le bouton  "Trouver" ou "Rechercher" **/
            jQuery('#search-offers-block').closest(".form__inner").first('.form__body').loading( 
                jQuery.ajax({
                    url : disko_ajax_object.ajaxurl,
                    type: 'post',
                    data: {
                        'action' : 'wp_get_agency_by_gps',
                        'lat'    : autocomplete.localisation.lat,
                        'lng'    : autocomplete.localisation.lng,
                    },
                    success: function (response) {
                        
                        if(response.success) {
                            
                            let data = JSON.parse(response.data);                                                                                        
                            /*
                                Si l'agence est nouvelle
                            */
                            if( Completude.isNewAgence(data.id) ) {
                                var url       = "/postuler/"
                                var agence_id = data.id;
                                
                                jQuery(document).on("agenceLoaded","",function(event,agence) {
                                    window.location = url;
                                })
                                window.Completude.UpdateAgence(data.id);
                            }
                            else {
                                /*
                                    Si la réponse contient un ID on redefini l'agence
                                    puis on redirige vers /offres-demploi/
                                */
                                if( data.agence_id ) {
                                    var url       = "/offres-demploi/";
                                    
                                    jQuery(document).on("agenceLoaded","",function(event,agence) { 
                                        window.location = url;
                                    })
                                    window.Completude.UpdateAgence(data.agence_id);
                                }
                                else {
                                    var url = "/offres-demploi/"
                                    window.location = url;
                                }
                            }
                        }
                        else {                                
                            var url = "/offres-demploi/"
                            window.location = url;
                        }
                    }
                }).promise()
            );                                                
        }
    }})(window);

jQuery(function() {      
    /**  Blocs "Trouver les offres de cours près de chez moi (Flexible content)" */
    if( jQuery('#section-bloc-recherche-offres').length > 0 ) {
        Completude.bloc_recherche_offres.InitBlocRechercheOffre();
    }   

});